module.exports = "/static/Images/en/VeryUnsatisfied.png";